import store from '../store'
import config from 'config'
let auth = []
if (config.env) {
  auth = [{
    match: '*',
    except: ['/login', '/register'],
    handler: function (route, next) {
      next(!!store.state.user && !!store.state.sessionToken)
    },
    fallbackUrl: '/login'
  }]
}
export default auth



// WEBPACK FOOTER //
// ./src/init/routeAuth.js